import React, { Component } from 'react'
import Linkify from 'react-linkify'

import PropTypes from 'prop-types'
import moment from 'moment'
import get from 'lodash/get'

import { DEFAULT_PROFILE_PIC_SRC } from './../../constants'
import { NotificationManager } from 'react-notifications'

export default class Comment extends Component {
  static propTypes = {
    isDeleteAvailable: PropTypes.bool,
    data: PropTypes.object,
    onDeleteClick: PropTypes.func
  }

  static defaultProps = {
    data: {}
  }

  async onDeleteClick(e) {
    e.stopPropagation()

    try {
      await this.props.onDeleteClick(this.props.data.id)
    } catch (err) {
      NotificationManager.error(err.message, 'Error', 5000)
    }
  }

  render() {
    return (
      <div className="comment">
        <div
          className="comment__photo"
          style={{
            backgroundImage: `url(${get(this.props, 'data.author.userProfile.imageAvatar.url', DEFAULT_PROFILE_PIC_SRC)})`
          }}
        />
        <div className="comment__content-wrapper">
          <span className="comment__author">
            {get(this.props, 'data.author.userProfile.firstName', '')}
            &nbsp;
            {get(this.props, 'data.author.userProfile.lastName', '')}
          </span>
          <span className="comment__date">{moment(get(this.props, 'data.createdAt', new Date())).fromNow()}</span>
          <Linkify><div className="comment__content">{get(this.props, 'data.content', '')}</div></Linkify>
          {this.props.isDeleteAvailable && (
            <div className="comment__delete-btn" onClick={e => this.onDeleteClick(e)}>
              Delete
            </div>
          )}
        </div>
      </div>
    )
  }
}



// WEBPACK FOOTER //
// src/components/MyTrip/Comment.js